<div style="display: flex; flex-direction: column; height: 100%; justify-content: space-between;">
  <app-navbar></app-navbar>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</div>